/**
 * @format
 * @module lib/audience/datalayer
 */
import {
  isLoggedIn,
  isAnonymous,
  isRegistered,
  isSubscribed,
  isGlobeAdvisor,
  isOnDemand
} from "lib/identity/api";
import merge from "lodash/merge";
import tgamConfig from "config/tgam";
import { setup as setupPageLayer } from "./page";
import setupArticleLayer from "./article";
import logger from "utils/logger";
import datalayerReady from "lib/audience/datalayer/ready";
import { getProp } from "utils/utils";

const debugTag = "[DATALAYER-INDEX]";

/**
 * Creates window.tgam.datalayer, an object holding all analytics page properties
 */
export function datalayerSetup() {
  window.tgam = window.tgam || {};
  window.tgam.datalayer = window.tgam.datalayer || {}; // Defined in head-inline-js-tgamConfig.jsp
  window.tgam.datalayer.page = merge(window.tgam.datalayer.page || {}, setupPageLayer()); // merge back-end with front-end
  window.tgam.datalayer.section = {}; // Keep this empty, but its not really used
  window.tgam.datalayer.article =
    tgamConfig.meta.isStoryPage || tgamConfig.meta.isVideoPage ? setupArticleLayer() : {};
}

/**
 * Updates window.tgam.datalayer, with param object values.
 * @param {Object} [datalayerObjects={}]
 */
export function datalayerUpdate(datalayerObjects = {}) {
  Object.keys(datalayerObjects).forEach(key => {
    if (!window.tgam.datalayer.hasOwnProperty(key)) {
      window.tgam.datalayer[key] = datalayerObjects[key];
    }
  });
}

/**
 * Debug logging for console of datalayer related values.
 */
export function datalayerLoggerInfo() {
  if (!logger.isDebug) {
    return;
  }
  logger.groupCollapsed(debugTag);
  logger.info(`${debugTag} datalayer:`, window.tgam.datalayer);
  logger.info(`${debugTag} ssvcs:`, getProp(window, "tgam.datalayer.identity.ssvcs"));
  logger.info(`${debugTag} isLoggedIn:`, isLoggedIn());
  logger.info(`${debugTag} isAnonymous:`, isAnonymous());
  logger.info(`${debugTag} isRegistered:`, isRegistered());
  logger.info(`${debugTag} isSubscribed:`, isSubscribed());
  logger.info(`${debugTag} isGlobeAdvisor:`, isGlobeAdvisor());

  logger.info(`${debugTag} isOnDemand:`, {
    premium: isOnDemand(), // any subtype
    enterprise: isOnDemand("enterprise") // specific subtype
  });

  logger.groupEnd(debugTag);
}

/**
 * Resolve the deferred promise. All instances .then'ed before and after will execute.
 */
export function datalayerReadyResolve() {
  // ee.trigger("analytics.datalayer:ready"); - Deprecated. Use below Deferred Promise.
  datalayerReady.resolve();
}
